<template>
  <div>
    <el-row>
        <div class="model-header">
        <h2>Tạo đề thi từ việc chọn từng câu hỏi</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
        </div>
    </el-row>
    <el-row>
        <div class="model-content">
        <el-col :span="24">
            <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel" @submit.native.prevent>
              <el-row :gutter="20">
                  <el-col :span="24">
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-card class="box-card">
                          <el-row :gutter="10">
                            <!-- Tên đề thi -->
                            <el-form-item prop="name" label="Tên đề thi" class="form-item">
                              <el-input v-model="modelData.name" placeholder="Tên đề thi" class="input-seach" clearable></el-input>
                            </el-form-item>
                          </el-row>

                          <el-row :gutter="10">
                            <el-form-item prop="type_time" label="Kiểu đề thi" class="form-item">
                              <el-select v-model="modelData.type_time" filterable placeholder="Kiểu đề thi" class="input-select">
                                <el-option
                                  v-for="item in lists.listTypeTime"
                                  :key="item.key"
                                  :label="item.value"
                                  :value="item.key">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-row>

                          <el-row :gutter="10">
                            <el-col :span="7">
                              <el-form-item prop="total_question" label="Số câu hỏi" class="form-item">
                                <el-input-number v-model="modelData.total_question" controls-position="right" @change="updateItemCount" :min="0" :max="300"
                                  auto-complete="off"
                                  class="input-seach"
                                  size="small"></el-input-number>
                              </el-form-item>
                            </el-col>
                            <el-col :span="7">
                              <el-form-item prop="time" label="Thời gian thi (phút)" class="form-item">
                                <el-input-number v-model="modelData.time" controls-position="right" :min="0" :max="300"
                                  auto-complete="off"
                                  class="input-seach"
                                  size="small"></el-input-number>
                              </el-form-item>
                            </el-col>
                          </el-row>

                          <el-row :gutter="10">
                            <el-col :span="14">
                              <el-form-item prop="score_success" label="Điểm đạt (Điểm số cần đạt để qua đề thi)" class="form-item">
                                <el-select v-model="modelData.score_success" filterable placeholder="Điểm đạt" class="input-select">
                                  <el-option
                                      v-for="item in lists.listScoreSuccess"
                                      :key="item.key"
                                      :label="item.value"
                                      :value="item.key">
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                          </el-row>

                        </el-card>
                      </el-col>

                      <el-col :span="12">
                        <el-card class="box-card">
                          <el-row :gutter="10">
                            <!-- Chọn trường -->
                            <el-form-item prop="school_id" label="Chọn trường" class="form-item">
                              <el-select v-model="modelData.school_id" filterable clearable placeholder="Chọn trường" class="input-select">
                                <el-option
                                  v-for="item in lists.listSchool"
                                  :key="item.id"
                                  :label="'(' + item.id + ') ' + item.name"
                                  :value="item.id">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-row>

                          <el-row :gutter="10">
                            <!-- Chọn phân hệ -->
                            <el-form-item prop="level_id" label="Chọn phân hệ" class="form-item">
                              <el-select v-model="modelData.level_id" filterable clearable placeholder="Chọn phân hệ" class="input-select">
                                <el-option
                                  v-for="item in lists.listLevel"
                                  :key="item.id"
                                  :label="'(' + item.id + ') ' + item.name"
                                  :value="item.id">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-row>

                          <el-row :gutter="10">
                            <!-- Chọn môn học -->
                            <el-form-item prop="course_id" label="Chọn môn học" class="form-item">
                              <el-select v-model="modelData.course_id" filterable clearable placeholder="Chọn môn học" class="input-select">
                                <el-option
                                  v-for="item in lists.listCourses"
                                  :key="item.id"
                                  :label="'(' + item.id + '-' + item.code + ') ' + item.name"
                                  :value="item.id">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-row>

                          <el-row :gutter="10">
                            <!-- Chọn chương -->
                            <el-form-item prop="chapter_id" label="Chọn chương" class="form-item">
                              <el-select v-model="modelData.chapter_id" filterable clearable placeholder="Chọn chương" class="input-select">
                                <el-option
                                  v-for="item in lists.listChapters"
                                  :key="item.id"
                                  :label="item.name"
                                  :value="item.id">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-row>

                        </el-card>
                      </el-col>
                    </el-row>

                  </el-col>
              </el-row>

              <el-row style="margin-top: 15px;">
                <el-col :span="12">
                  <el-col :span="12">
                    <el-form-item>
                      <el-button
                        :disable="!canSearch"
                        :loading="!canSearch"
                        type="success"
                        icon="el-icon-search"
                        size="small"
                        plain
                        @click="fetchQuestions('createModel')"
                      >
                        Tải câu hỏi
                      </el-button>
                      <el-button
                        type="warning"
                        size="small"
                        plain
                        @click="backModel"
                      >
                        Trở về
                      </el-button>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12" style="text-align: right">
                    <el-form-item>
                      <el-button
                        :disabled="!canSubmit || !(modelData.list_questions.length > 0)"
                        :loading="!canSubmit"
                        type="primary"
                        size="small"
                        plain
                        @click="submitForm('createModel')"
                      ><i class="fa fa-save"></i> Lưu lại đề thi</el-button>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>

            </el-form>
          </el-col>
        </div>
    </el-row>

    <el-row>
      <div v-loading="loading" class="columns-container">
        <div class="column">
          <h3 style="line-height: 32px;" v-if="(modelData.list_questions.length == modelData.total_question && modelData.total_question > 0)">Tổng số câu tìm được: {{ lists.listQuestions.length }} câu</h3>
          <h3 v-else>Tổng số câu tìm được: {{ lists.listQuestions.length }} câu</h3>
          <el-row>
            <el-col :span="18">
              <label style="color: #67c23a;">(Nhấp chuột chọn câu hỏi, câu sẽ được chuyển qua mục được chọn bên phải)</label>
            </el-col>
            <el-col :span="6" style="text-align: right;">
              <el-button plain style="margin-top: 0px !important;" :disabled="!(lists.listQuestions.length > 0)" type="success" size="small" @click="quickAddToColumn2()">
                <i class="far fa-arrow-alt-circle-right"></i> Chọn nhanh
              </el-button>
            </el-col>
          </el-row>
          <ul class="item-list">
            <li class="outter-card" v-for="item in lists.listQuestions" :key="item.id">
              <button class="button-card" :disabled="item.disabled" @click="addToColumn2(item)">
                <div class="question">{{ item.text }}</div>
                <ul class="answers">
                  <li class="answer-items" v-for="(option, index) in item.options" :key="index">
                    <label v-if="option.is_answer" style="color: green">
                      {{ String.fromCharCode(65 + index) }}. {{ option.text }}
                    </label>
                    <label v-else>
                      {{ String.fromCharCode(65 + index) }}. {{ option.text }}
                    </label>
                  </li>
                </ul>
              </button>
            </li>
          </ul>
        </div>

        <div class="column">
          <el-row>
            <h3>Tổng số câu đã chọn: {{ modelData.list_questions.length }}/{{ modelData.total_question }} câu
              <el-button style="margin-top: 0px !important;" v-if="(modelData.list_questions.length == modelData.total_question && modelData.total_question > 0)"
              type="primary"
              size="small"
              plain
              @click="showModel()">
              <i class="fa fa-eye"></i> Xem trước đề thi
            </el-button>
            </h3>
          </el-row>

          <el-row>
            <el-col :span="18">
              <label style="color: red;">(Nhấp chuột chọn câu hỏi để loại bỏ câu đã chọn)</label>
            </el-col>
            <el-col :span="6" style="text-align: right">
              <el-button plain style="margin-top: 0px !important;" :disabled="!(modelData.list_questions.length > 0)" type="danger" icon="el-icon-delete" size="small" @click="quickDeleteFromColumn2()">Xóa nhanh</el-button>
            </el-col>
          </el-row>
          <ul class="item-list">
            <li class="outter-card" v-for="item in modelData.list_questions" :key="item.id">
              <button class="button-card" @click="removeFromColumn2(item)">
                <div class="question">{{ item.text }}</div>
                <ul class="answers">
                  <li class="answer-items" v-for="(option, index) in item.options" :key="index">
                    <label v-if="option.is_answer" style="color: green">
                      {{ String.fromCharCode(65 + index) }}. {{ option.text }}
                    </label>
                    <label v-else>
                      {{ String.fromCharCode(65 + index) }}. {{ option.text }}
                    </label>
                  </li>
                </ul>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </el-row>

    <!-- preview dialog -->
    <el-dialog
      :close-on-click-modal="false"
      :title="'Xem trước đề thi'"
      :visible.sync="dialogVisible"
      top="20px"
      width="85%">
      <div>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="questions-list-preview">
              <div class="item-question" v-for="(question, indexQuestion) in modelData.list_questions" :key="indexQuestion">
                <div>
                  <strong>Câu {{ indexQuestion + 1 }} : </strong>
                  <strong v-html="question.text"></strong>
                </div>
                <div class="list-options test-options" v-if="question.type_question == 1">
                  <ul class="answers">
                    <li class="answer-items" v-for="(option, index) in question.options" :key="index">
                      <label v-if="option.is_answer && showResult" style="color: green">
                        {{ String.fromCharCode(65 + index) }}. {{ option.text }}
                      </label>
                      <label v-else>
                        {{ String.fromCharCode(65 + index) }}. {{ option.text }}
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disable="!canSubmit" :loading="!canSubmit"
          @click="submitForm('createModel')" size="small" plain><i class="fa fa-save"></i> Lưu lại đề thi</el-button>
        <el-button type="success" @click="showResultClick()" size="small" plain>{{ showResultText }}</el-button>
        <el-button @click="dialogVisible = false" size="small" plain type="info">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import { head } from 'lodash'
  import { mapActions } from 'vuex'
  export default {
    name: 'MultipleChoiceManualCreate',
    metaInfo () {
      return {
        title: 'Tạo đề thi từ việc chọn từng câu hỏi'
      }
    },
    data () {
      return {
        canSubmit: true,
        modelData: {
          name: '',
          school_id: '',
          level_id: '',
          course_id: '',
          chapter_id: '',
          type: 3,
          time: 15,
          type_time: 0,
          type_question: 1,
          score_success: 6,
          status: true,
          total_question: 0,
          list_questions: [],
        },
        configData: {
          course: {
            id: 0,
            name: 'Tên khóa này'
          },
          chapter: {
            id: 0,
            name: 'Tên chương này'
          }
        },
        lists: {
          listTypeTime: [
            {key: 0, value: 'Không chọn'},
            {key: 1, value: 'Kiểm tra 15 phút'},
            {key: 2, value: 'Kiểm tra 1 tiết'},
            {key: 12, value: 'Kiểm tra giữa môn'},
            {key: 14, value: 'Kiểm tra kết thúc môn'},
            {key: 15, value: 'Kiểm tra cuối kỳ'}
          ],
          listScoreSuccess: [
            {key: 0, value: '0 điểm'},
            {key: 0.5, value: '0,5 điểm'},
            {key: 1, value: '1 điểm'},
            {key: 1.5, value: '1.5 điểm'},
            {key: 2, value: '2 điểm'},
            {key: 2.5, value: '2.5 điểm'},
            {key: 3, value: '3 điểm'},
            {key: 3.5, value: '3.5 điểm'},
            {key: 4, value: '4 điểm'},
            {key: 4.5, value: '4.5 điểm'},
            {key: 5, value: '5 điểm'},
            {key: 5.5, value: '5.5 điểm'},
            {key: 6, value: '6 điểm'},
            {key: 6.5, value: '6.5 điểm'},
            {key: 7, value: '7 điểm'},
            {key: 7.5, value: '7.5 điểm'},
            {key: 8, value: '8 điểm'},
            {key: 8.5, value: '8.5 điểm'},
            {key: 9, value: '9 điểm'},
            {key: 9.5, value: '9.5 điểm'},
            {key: 10, value: '10 điểm'}
          ],
          listCategoryTest: [],
          listSchool: [],
          listLevel: [],
          listCourses: [],
          listChapters: [],
          listQuestions: [],
        },
        loading: false,
        canSearch: true,
        dialogVisible: false,
        showResult: true,
        showResultText: 'Ẩn đáp án',
        rules: {
          name: [
            { required: true, message: 'Vui lòng nhập tên đề thi' },
            { min: 2, max: 191, message: 'Tên bài học có chiều dài từ 2 tới 191 kí tự' }
          ],
          total_question: [
            { required: true, message: 'Vui lòng nhập số lượng câu hỏi' },
          ],
          time: [
            { required: true, message: 'Vui lòng nhập thời gian thi' },
          ],
          school_id: [
            { required: true, message: 'Vui lòng chọn trường' }
          ],
          level_id: [
            { required: true, message: 'Vui lòng chọn phân hệ' }
          ],
          course_id: [
            { required: true, message: 'Vui lòng chọn môn học' }
          ],
        }
      }
    },
    mounted () {
      this.configBreadcrumb()
      this.fetchSchool()
    },
    methods: {
      // Lấy action từ Vuex
      ...mapActions(['setBreadcrumb']),
      // Cấu hình dữ liệu về khóa học, bài, cấu hình Breadcrumb
      configDataAndBreadcrumb () {
        this.modelData.course_id = this.$route.params.course_id
        this.modelData.chapter_id = this.$route.params.chapter_id
        this.fetchCourse()
      },
      fetchSchool () {
        axios.get('schools', {params: {'status': 1, 'limit': -1}}).then(response => {
          switch (response.code) {
            case 200:
              this.lists.listSchool = response.data
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },
      fetchLevel () {
        let data = {
          'status': 1,
          'limit': -1,
          'school_id': this.modelData.school_id
        }
        axios.get('levels', {params: data}).then(response => {
          switch (response.code) {
            case 200:
              this.lists.listLevel = response.data
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },
      fetchAllCourses () {
        axios.get('levels/all-courses/' + this.modelData.level_id).then(response => {
          switch (response.code) {
            case 200:
              this.lists.listCourses = response.data
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },
      fetchChapter () {
        let data = {
          'status': 1,
          'limit': -1,
          'course_id': this.modelData.course_id
        }
        axios.get('chapters', {params: data}).then(response => {
          switch (response.code) {
            case 200:
              this.lists.listChapters = response.data
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      },
      fetchQuestions (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let data = {
              'status': 1,
              'limit': -1,
              'course_id': this.modelData.course_id,
              'chapter_id': this.modelData.chapter_id
            }
            this.loading = true
            this.canSearch = false
            axios.get('questions', {params: data}).then(response => {
              switch (response.code) {
                case 200:
                  this.lists.listQuestions = response.data
                  break
                default:
                  this.$notify.error({
                    title: 'Error',
                    message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                  })
                  break
              }
              this.loading = false
              this.canSearch = true
            })
          } else {
            this.$notify({
              title: 'Lỗi dữ liệu nhập',
              message: 'Vui lòng kiểm tra lại thông tin',
              type: 'warning'
            })
            return false
          }
        })
      },
      addToColumn2(item) {
        if (this.modelData.total_question <= 0) {
          this.$alert('Vui lòng nhập vào [Số câu hỏi] của đề thi', 'Có lỗi xảy ra', {
            confirmButtonText: 'OK',
            callback: action => {}
          });
        } else {
          if (this.modelData.list_questions.length < this.modelData.total_question) {
            item.disabled = true;
            this.modelData.list_questions.push(item);
          }
        }
      },
      removeFromColumn2(item) {
        const index = this.modelData.list_questions.findIndex((i) => i.id === item.id);
        if (index !== -1) {
          this.modelData.list_questions.splice(index, 1);
          const correspondingItem = this.lists.listQuestions.find(
            (i) => i.id === item.id
          );
          if (correspondingItem) {
            correspondingItem.disabled = false;
          }
        }
      },
      updateItemCount() {
        if (this.modelData.list_questions.length > this.modelData.total_question) {
          const extraItemsCount = this.modelData.list_questions.length - this.modelData.total_question;
          const itemsToRemove = this.modelData.list_questions.slice(-extraItemsCount);
          itemsToRemove.forEach(item => this.removeFromColumn2(item));
        }
      },
      getRandomItems(array, count) {
        const shuffledArray = array.sort(() => Math.random() - 0.5);
        return shuffledArray.slice(0, count);
      },
      quickAddToColumn2() {
        if (this.modelData.total_question <= 0) {
          this.$alert('Vui lòng nhập vào [Số câu hỏi] của đề thi', 'Có lỗi xảy ra', {
            confirmButtonText: 'OK',
            callback: action => {}
          });
        } else {
          if (this.modelData.list_questions.length < this.modelData.total_question) {
            const extraItemsCount = this.modelData.total_question - this.modelData.list_questions.length;
            const filteredList = this.lists.listQuestions.filter(itemA => !this.modelData.list_questions.some(itemB => itemB.id === itemA.id));
            const additionalItems = this.getRandomItems(filteredList, extraItemsCount);

            additionalItems.forEach(item => this.addToColumn2(item));
          } else {
            this.updateItemCount();
          }
        }
      },
      quickDeleteFromColumn2() {
        const itemsToRemove = this.modelData.list_questions.slice(-this.modelData.list_questions.length);
        itemsToRemove.forEach(item => this.removeFromColumn2(item));
      },
      showModel() {
        this.dialogVisible = true;
        this.showResult = true;
      },
      showResultClick() {
        this.showResult = !this.showResult;
        this.showResultText = this.showResult ? 'Ẩn đáp án' : 'Hiện đáp án';
      },
      configBreadcrumb () {
        let breadcrumb = [
          { name: 'home-index', text: 'Trang chủ' },
          { name: 'test-kits-online-index', text: 'Đề thi trắc nghiệm' },
          { name: 'chapters-index', text: 'Tạo đề thủ công' }
        ]
        this.setBreadcrumb(breadcrumb)
      },
      // Nút back lại trang Index
      backModel () {
        this.$router.push({name: 'test-kits-online-index'})
      },
      // Lưu dữ liệu
      submitForm (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.storeModel()
          } else {
            this.$notify({
              title: 'Lỗi dữ liệu nhập',
              message: 'Vui lòng kiểm tra lại thông tin',
              type: 'warning'
            })
            return false
          }
        })
      },
      storeModel () {
        this.canSubmit = false
        axios.post('test-kits/create-v2', this.modelData).then(response => {
          this.canSubmit = true
          switch (response.code) {
            case 200:
              this.$notify({
                title: 'Thành công',
                message: 'Thêm đề thi thành công',
                type: 'success'
              })

              this.$router.push({name: 'test-kits-online-index'})
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$notify({
                title: 'Có lỗi xảy ra',
                message: message,
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      }
    },
    watch: {
      'modelData.school_id': function () {
        this.modelData.level_id = ''
        this.lists.listLevel = []

        if (this.modelData.school_id) {
          this.fetchLevel()
        }
      },
      'modelData.level_id': function () {
        this.modelData.course_id = ''
        this.lists.listCourses = []

        if (this.modelData.level_id) {
          this.fetchAllCourses()
        }
      },
      'modelData.course_id': function () {
        this.modelData.chapter_id = ''
        this.lists.listChapters = []

        if (this.modelData.course_id) {
          this.fetchChapter()
        }
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
  .model-content {
      padding-top: 15px;
  }
  .course {
      width: 280px;
      height: 200px;
      display: block;
  }

  .form-container {
      display: flex;
      flex-direction: column;
  }

  .input-container {
      margin-bottom: 10px;
  }

  .columns-container {
      display: flex;
      gap: 20px;
      border-top: 1px solid #dcdfe6;
      height: 850px;
  }

  .column {
      flex: 1;
  }

  .item-list {
      max-height: 700px;
      overflow-y: auto;
      padding-inline-start: 0px;
  }

  .question {
    font-weight: bold;
    margin-bottom: 5px;
    text-align: left !important;
    font-size: 14px;
  }

  .answers {
    list-style-type: none;
    padding-left: 0;
    margin-top: 0;
    text-align: left !important;
    font-size: 14px;
  }

  button {
      margin-top: 10px;
  }

  .outter-card {
    width: 100%;
    list-style-type: none;
    /* border: 1px solid #dcdfe6; */
    /* padding: 5px; */
    margin-bottom: 5px;
    /* background-color: #fff; */
    background-image: none;
    /* border-radius: 4px; */
  }
  .answer-items {
    padding: 3px;
  }

  .column-title {
    display: block;
    font-size: 1.17em;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
  }

  .button-card {
    /* border: none !important; */
    padding: 10px 6px 10px 6px;
    border: 1px solid #dcdfe6 !important;
    background-color: #fff;
    margin-top: 0px;
    width: 100%;
    border-radius: 4px;
  }
  .button-card:disabled {
    border: 2px solid #67c23a !important;
  }

  ul {
      list-style-type: none;
  }

  .questions-list-preview {
    height: 720px;
    overflow-y: scroll;
  }

  .el-input-number--small {
    width: 100% !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/test-kits-online/MultipleChoiceManualCreate.vue